// Peças de interface no estilo do cliente oficial (molduras, botões e campos).
import type { ComponentChildren } from 'preact';

export function Window(props: { title: string; children: ComponentChildren; width?: number; class?: string }) {
  return (
    <div class={'tb-window ' + (props.class ?? '')} style={props.width ? { width: props.width + 'px' } : undefined}>
      <div class="tb-window-title">{props.title}</div>
      <div class="tb-window-body">{props.children}</div>
    </div>
  );
}

export function Button(props: { children: ComponentChildren; onClick?: () => void; type?: 'button' | 'submit'; disabled?: boolean; variant?: 'green' | 'red' | 'normal' }) {
  return (
    <button type={props.type ?? 'button'} class={'tb-button ' + (props.variant ?? 'normal')} disabled={props.disabled} onClick={props.onClick}>
      {props.children}
    </button>
  );
}

export function Field(props: { label: string; type?: string; value: string; onInput: (v: string) => void; autoComplete?: string; maxLength?: number; autoFocus?: boolean }) {
  return (
    <label class="tb-field">
      <span>{props.label}</span>
      <input
        type={props.type ?? 'text'}
        value={props.value}
        maxLength={props.maxLength}
        autoComplete={props.autoComplete}
        autoFocus={props.autoFocus}
        onInput={(e) => props.onInput((e.target as HTMLInputElement).value)}
      />
    </label>
  );
}

export function Checkbox(props: { checked: boolean; onChange: (v: boolean) => void; children: ComponentChildren }) {
  return (
    <label class="tb-checkbox">
      <input type="checkbox" checked={props.checked} onChange={(e) => props.onChange((e.target as HTMLInputElement).checked)} />
      <i />
      <span>{props.children}</span>
    </label>
  );
}

export function ErrorText(props: { error: string | null }) {
  return props.error ? <p class="tb-error" role="alert">{props.error}</p> : null;
}

export function Bar(props: { kind: 'health' | 'mana'; value: number; max: number }) {
  const pct = props.max > 0 ? Math.max(0, Math.min(100, (props.value / props.max) * 100)) : 0;
  return (
    <div class={'tb-bar ' + props.kind}>
      <div class="fill" style={{ width: pct + '%' }} />
      <span>{props.value} / {props.max}</span>
    </div>
  );
}
